import {useEffect, useRef} from 'react';
import type {RoomWithLastMessage} from './useMatrix';

export interface InitialRoomAutoSelectOptions {
    isReady: boolean;
    restoreSettled: boolean;
    selectedRoomId: string | null;
    hasPendingDeepLink: boolean;
    isExplicitSelectionPending: () => boolean;
    rooms: RoomWithLastMessage[];
    selectRoom: (roomId: string) => void | Promise<void>;
}

export const pickInitialRoomId = (rooms: RoomWithLastMessage[]): string | null => {
    const candidate = rooms.find(row => !row.isLocal && row.room && !row.room.isSpaceRoom());
    return candidate?.roomId ?? null;
};

export const useInitialRoomAutoSelect = ({
    isReady,
    restoreSettled,
    selectedRoomId,
    hasPendingDeepLink,
    isExplicitSelectionPending,
    rooms,
    selectRoom,
}: InitialRoomAutoSelectOptions): void => {
    const doneRef = useRef(false);

    useEffect(() => {
        if (!restoreSettled) {
            doneRef.current = false;
            return;
        }
        if (doneRef.current || !isReady) return;
        if (selectedRoomId || hasPendingDeepLink || isExplicitSelectionPending()) {
            doneRef.current = true;
            return;
        }
        const roomId = pickInitialRoomId(rooms);
        if (!roomId) return;
        doneRef.current = true;
        void selectRoom(roomId);
    }, [isReady, restoreSettled, selectedRoomId, hasPendingDeepLink, isExplicitSelectionPending, rooms, selectRoom]);
};
